import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import ContentStyles from './Content.styles';
import pluralize from 'pluralize';
import {
  PACKAGE_TYPE_NOT_APPLICABLE,
  PACKAGE_TYPE_PIECE
} from '../../../constants/constants';

export class Content extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    packageTypeId: PropTypes.string,
    shipmentItems: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    units: PropTypes.array.isRequired,
    unit: PropTypes.object.isRequired
  };

  state = { expanded: false };

  _handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const {
      classes,
      name,
      shipmentItems = {},

      products = [],
      units = [],
      unit = {}
    } = this.props;

    const productIds = shipmentItems.map(
      shipmentItem => shipmentItem.product.name
    );
    let totalPackageCounts = '--';
    // if package type is "not applicable" it was decided to change it to PIECES
    if (unit && unit.unitCount) {
      totalPackageCounts =
        unit.packageTypeId === PACKAGE_TYPE_NOT_APPLICABLE
          ? `${unit.unitCount} ${pluralize(PACKAGE_TYPE_PIECE, unit.unitCount)}`
          : `${unit.unitCount} ${pluralize(
              unit.packageTypeId,
              unit.unitCount
            )}`;
    }
    return (
      <div className={classes.root}>
        <div className={classes.header} onClick={this._handleExpandClick}>
          <p className={classes.name}>{name}</p>
          <p className={classes.productIds}>{productIds.join(', ')}</p>
          <p className={classes.pallet}>{`${totalPackageCounts}`}</p>
          <IconButton
            className={classnames(classes.expandButton, {
              [classes.expandOpen]: this.state.expanded
            })}
            aria-expanded={this.state.expanded}
            aria-label="Show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </div>
        <Collapse
          in={this.state.expanded}
          timeout="auto"
          unmountOnExit
          className={classes.body}
        >
          <div className={classes.products}>{products}</div>
          <div className={classes.units}>{units}</div>
        </Collapse>
      </div>
    );
  }
}

export default withStyles(ContentStyles)(Content);
